import WorkReportView from "./WorkReportView.vue"
import WorkReportEdit from "./WorkReportEdit.vue"
import AbsenceReportView from "./AbsenceReportView.vue"
import AbsenceReportEdit from "./AbsenceReportEdit.vue"

const base = "/workreport"

export default [
    {
        path: base + "/new",
        name: "workreportnew",
        props: { new: true },
        component: WorkReportEdit,
    },
    {
        path: base + "/:uuid",
        name: "workreport",
        props: true,
        component: WorkReportView,
    },
    {
        path: base + "/:uuid/edit",
        name: "workreportedit",
        props: true,
        component: WorkReportEdit,
    },
    {
        path: base + "/job/:jobUuid",
        name: "workreportforjob",
        props: true,
        component: WorkReportEdit,
    },
    {
        path: base + "/job/:jobUuid/userId/:userId",
        name: "workreportforjobuser",
        props: true,
        component: WorkReportEdit,
    },
    {
        path: base + "/absence/new",
        name: "reportabsencenew",
        props: { new: true },
        component: AbsenceReportEdit,
    },
    {
        path: base + "/absence/:uuid",
        name: "absence",
        props: true,
        component: AbsenceReportView,
    },
    {
        path: base + "/absence/:uuid/edit",
        name: "absenceedit",
        props: true,
        component: AbsenceReportEdit,
    },
]
